const SideMenuCategoryLangKey = [
	'affiliate_title',
	'revenue_title',
	'profile_title'
] as const

type ISideMenuCategoryLangKey = typeof SideMenuCategoryLangKey[number]

export type ISideMenuCategoryLang = {
	side_menu_category: Record<ISideMenuCategoryLangKey, string>
}

const langEntries = SideMenuCategoryLangKey.map(
	(key: ISideMenuCategoryLangKey) => [key, `side_menu_category.${key}`]
)

const langObj: Record<ISideMenuCategoryLangKey, string> = Object.fromEntries(langEntries)

export const SIDE_MENU_CATEGORY_LANG_KEY: ISideMenuCategoryLang = {
	side_menu_category: langObj
}